import React from "react";
import KpiPerDayGraphs from "./components/graphs/kpi-per-day-graphs";
import Checks from "./components/checks/checks";
import KpiPerHoursGraphs from "./components/graphs/kpi-per-hours-graphs";
import { KpiLastMinutesGraphs } from "./components/graphs/kpi-last-minutes-graphs";

function App() {
  return (
    <div className="bg-slate-500">
      <Checks />
      <KpiLastMinutesGraphs />
      <KpiPerHoursGraphs />
      <KpiPerDayGraphs />
    </div>
  );
}

export default App;
